module.exports = __webpack_public_path__ + "img/android.29958764.svg";